import MetaFeatureList from './FeatureList'

MetaFeatureList.install = function (Vue) {
    Vue.component(MetaFeatureList.name, MetaFeatureList)
}

export default MetaFeatureList;